var loginCoop;
(function (loginCoop) {
    document.addEventListener('ControllerReady', () => {
        var _a, _b, _c, _d, _e;
        var imageMap = new Map();
        imageMap.set('35', '/sites/default/files/2020-05/alleanza2x.jpg');
        imageMap.set('1', '/sites/default/files/2020-05/novacoop2x.jpg');
        imageMap.set('2', '/sites/default/files/2020-05/liguria2x.jpg');
        imageMap.set('3', '/sites/default/files/2020-05/lombardia2x.jpg');
        imageMap.set('7', '/sites/default/files/2023-10/CoopFi_10ragioni.png');
        imageMap.set('8', '/sites/default/files/2025-06/Unicoop_Etruria.jpg');
        imageMap.set('9', '/sites/default/files/2020-05/centroitala2x.jpg');
        imageMap.set('15', '/sites/default/files/2021-11/coop-reno.jpeg');
        imageMap.set('22', '/sites/default/files/2021-12/coop-unione-amiatina-logo.png');
        imageMap.set('44', '/sites/default/files/2021-12/doc-roma-logo.png');
        imageMap.set('36', '/sites/default/files/2021-12/coop-trentina-logo.jpg');
        var password = '';
        var email = '';
        var coopId = null;
        var globalToken = '';
        var globalCoopId = null;
        let pdvID = 'null';
        let etruriaModal = document.querySelector('.etruria-login-modal');
        const chiudiBtn = etruriaModal === null || etruriaModal === void 0 ? void 0 : etruriaModal.querySelector('#chiudi-modale');
        const checkbox = etruriaModal === null || etruriaModal === void 0 ? void 0 : etruriaModal.querySelector('#non-mostrare-piu');
        const iconCloseModal = etruriaModal === null || etruriaModal === void 0 ? void 0 : etruriaModal.querySelector('#chiudi-x');
        let modal_reset_psw = document.querySelector('.login-alleanza-redirect');
        const $body = document.querySelector('body');
        var responseUserPrivacy = null;
        var notNazionale = [35, 1, 2, 3, 15, 8];
        var showPrivacyModal = false;
        const $errordiv = document.querySelector('#errorDiv');
        const $errorLab = document.querySelector('#errorLabel');
        var cooperativaMessageDiv = document.querySelector('#cooperativaMessageDiv');
        const $formLoginDiv = document.querySelector('#formLoginDiv');
        const $coopLoginDiv = document.querySelector('#CoopSelectLoginDiv');
        const $wrapperCoopLoginSub = document.querySelector('#sub-wrapper');
        let togglePassword = document.getElementById('togglePassword');
        let passwordT = document.getElementById('password');
        let iconPassword = document.querySelector('.iconPassword');
        togglePassword.addEventListener('click', setPasswordField);
        function getCookie(cname) {
            let name = cname + '=';
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }
        let cpvUtente = "";
        const queryString = window.location.search;
        if (queryString) {
            (_a = $formLoginDiv.querySelector('#choose-cpv')) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
            (_b = $formLoginDiv.querySelector('#form-login')) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
            const urlParams = new URLSearchParams(queryString);
            cpvUtente = urlParams.get('cpvUtente');
            selectCooperativa(cpvUtente);
        }
        else if (getCookie('cpvUtente') != '') {
            cpvUtente = getCookie('cpvUtente');
            let cID = cpvUtente.split('|')[0];
            if (cID != '9') {
                (_c = $formLoginDiv.querySelector('#choose-cpv')) === null || _c === void 0 ? void 0 : _c.classList.add('d-none');
                (_d = $formLoginDiv.querySelector('#form-login')) === null || _d === void 0 ? void 0 : _d.classList.remove('d-none');
                document.querySelector('#remember-cpv').checked = true;
                selectCooperativa(cpvUtente);
            }
            else {
                cpvUtente = "";
            }
        }
        printCoopeativeMessage(cpvUtente);
        (_e = document.querySelector('#remember-cpv')) === null || _e === void 0 ? void 0 : _e.addEventListener('click', setCpvUtenteCookie);
        const config = retrieveConfig(document);
        const getServicesEndpoint = `/api/esb/user/login?_format=form`;
        const ServicesEndpointPro = `/api/esb/user/getProfile?_format=form`;
        const endpointSetPrivacy = `/api/esb/user/setPrivacy?_format=form`;
        const endpointGetPrivacy = `/api/esb/user/getPrivacyDisclaimers?_format=form`;
        const ServicesEndpointRes = `/api/esb/user/resendEmailAddressVerificationCode?_format=form`;
        const device = 'web';
        const loginForm = document.querySelector('.loginForm');
        loginForm.addEventListener('submit', handleFormSubmit);
        function printCoopeativeMessage(cpvUtente) {
            cooperativaMessageDiv.innerHTML = '';
            if (cpvUtente != null && cpvUtente == '7|Coop-Firenze') { 
                cooperativaMessageDiv.innerHTML = "<p>Se è il tuo <b>primo accesso</b> al sito, devi effettuare la <b>registrazione</b>.</p>";
            }
            else if (cpvUtente != null) {
                cooperativaMessageDiv.innerHTML = "<p>Se sei <b>già registrato alla cooperativa</b>, puoi utilizzare i tuoi <b>dati d'accesso per accedere</b>.</p>";
            }
        }
        function setPasswordField(event) {
            event.preventDefault();
            let iconPassword = document.querySelector('.iconPassword');
            if (passwordT.type == 'password') {
                passwordT.type = 'text';
                iconPassword.classList.remove('fa-eye-slash');
                iconPassword.classList.add('fa-eye');
            }
            else {
                passwordT.type = 'password';
                iconPassword.classList.add('fa-eye-slash');
                iconPassword.classList.remove('fa-eye');
            }
        }
        function setCpvUtenteCookie(event) {
            setRememberCPVCookie('cpvUtente', cpvUtente);
        }
        function selectCooperativa(cpvUtente) {
            var _a, _b;
            let cooperativa = cpvUtente.split('|')[1];
            let cID = cpvUtente.split('|')[0];
            coopId = cID;
            (_a = modal_reset_psw === null || modal_reset_psw === void 0 ? void 0 : modal_reset_psw.querySelector('.accept')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
                modal_reset_psw === null || modal_reset_psw === void 0 ? void 0 : modal_reset_psw.classList.add('d-none');
                $body === null || $body === void 0 ? void 0 : $body.classList.remove('scrollLock');
                window.location.href = `/auth/resetPassword/request?cooperativa=${cID}&cpvName=${cooperativa}`;
            });
            document.getElementById('resetPwdLink').href = `/auth/resetPassword/request?cooperativa=${cID}&cpvName=${cooperativa}`;
            document.getElementById('resetPwdLinkMobile').href = `/auth/resetPassword/request?cooperativa=${cID}&cpvName=${cooperativa}`;
            if (cID == '35')
                pdvID = cpvUtente.split('|')[2];
            let $filter;
            switch (cID) {
                case '35': 
                    $filter = document.querySelector('.CA3');
                    $filter.classList.remove('hidden');
                    break;
                case '9': 
                    $filter = document.querySelector('.CCI');
                    $filter.classList.remove('hidden');
                    break;
                case '22': 
                    $filter = document.querySelector('.CAM');
                    $filter.classList.remove('hidden');
                    break;
                case '44': 
                    $filter = document.querySelector('.DRM');
                    $filter.classList.remove('hidden');
                    break;
                case '36': 
                    $filter = document.querySelector('.CTR');
                    $filter.classList.remove('hidden');
                    break;
                case '3': 
                    $filter = document.querySelector('.CLO');
                    $filter.classList.remove('hidden');
                    break;
                case '1': 
                    $filter = document.querySelector('.NOVA');
                    $filter.classList.remove('hidden');
                    break;
                case '7': 
                    $filter = document.querySelector('.CFI');
                    $filter.classList.remove('hidden');
                    break;
                case '8': 
                    $filter = document.querySelector('.CTI');
                    $filter.classList.remove('hidden');
                    (_b = document.querySelector('.info-remember-cpv-etruria-login')) === null || _b === void 0 ? void 0 : _b.classList.remove('hidden');
                    showEtruriaModal();
                    break;
                case '2': 
                    $filter = document.querySelector('.CLI');
                    $filter.classList.remove('hidden');
                    break;
                case '15': 
                    $filter = document.querySelector('.CRO');
                    $filter.classList.remove('hidden');
                    break;
                case '22': 
                    $filter = document.querySelector('.CAM');
                    $filter.classList.remove('hidden');
                    break;
                case '44': 
                    $filter = document.querySelector('.DRM');
                    $filter.classList.remove('hidden');
                    break;
                case '36': 
                    $filter = document.querySelector('.CTR');
                    $filter.classList.remove('hidden');
                    break;
                default:
                    $filter = document.querySelector('.DEFAULT');
                    $filter.classList.remove('hidden');
                    break;
            }
            document.querySelector('#defaultCpvApp').innerHTML = cooperativa.replace('-', ' ');
            const btn = $formLoginDiv.querySelector('#button-register');
            btn === null || btn === void 0 ? void 0 : btn.addEventListener('click', () => {
                goToRegister(cooperativa, cID, pdvID);
            });
            setPrivacyLink();
        }
        function goToRegister(cooperativa, cID, pdvID) {
            const url = cID === '35'
                ? `/auth/register/${cooperativa}/${cID}/${pdvID}`
                : `/auth/register/${cooperativa}/${cID}`;
            dataLayer.push({
                event: 'registrazione_account_start',
                step_registrazione: 'entra_nel_mondo_coop',
                eventCallback: function () {
                    window.location.href = url;
                },
                eventTimeout: 500
            });
        }
        function hideEtruriaModal() {
            etruriaModal === null || etruriaModal === void 0 ? void 0 : etruriaModal.classList.add('d-none');
            $body === null || $body === void 0 ? void 0 : $body.classList.remove('scrollLock');
        }
        function showEtruriaModal() {
            if (!localStorage.getItem('hideEtruriaLoginModal')) {
                etruriaModal === null || etruriaModal === void 0 ? void 0 : etruriaModal.classList.remove('d-none');
                $body === null || $body === void 0 ? void 0 : $body.classList.add('scrollLock');
            }
            chiudiBtn === null || chiudiBtn === void 0 ? void 0 : chiudiBtn.addEventListener('click', function () {
                if (checkbox === null || checkbox === void 0 ? void 0 : checkbox.checked) {
                    localStorage.setItem('hideEtruriaLoginModal', 'true');
                }
                hideEtruriaModal();
            });
            iconCloseModal === null || iconCloseModal === void 0 ? void 0 : iconCloseModal.addEventListener('click', function () {
                hideEtruriaModal();
            });
        }
        function retrieveConfig($wrapper) {
            let data;
            const $form = $wrapper && $wrapper.querySelector('.ep-config');
            if ($form) {
                try {
                    const url = $form.querySelector('[name="url"]').value;
                    const config = $form.querySelector('[name="config"]').value;
                    data = {
                        url: url.replace(/\/$/, ''),
                        config: JSON.parse(config),
                    };
                }
                catch (e) {
                    console.log('Error during retrieval of configuration for current service. %s', e);
                }
            }
            return data;
        }
        function retrieveEmail($wrapper) {
            let data;
            const $form = $wrapper && $wrapper.querySelector('.loginForm');
            if ($form) {
                try {
                    data = $form.querySelector('[id="email"]').value;
                }
                catch (e) {
                    console.log('Error during retrieval of parameter for current service. %s', e);
                }
            }
            return data;
        }
        function retrievePassword($wrapper) {
            let data;
            const $form = $wrapper && $wrapper.querySelector('.loginForm');
            if ($form) {
                try {
                    data = $form.querySelector('[id="password"]').value;
                }
                catch (e) {
                    console.log('Error during retrieval of parameter for current service. %s', e);
                }
            }
            return data;
        }
        function retrieveCoopIdCooperativa() {
        }
        function handleFormSubmit(event) {
            event.preventDefault();
            email = retrieveEmail(document);
            password = retrievePassword(document);
            $formLoginDiv.setAttribute('data-spinner', 'mask');
            loginAttempt(coopId, email, password, device, $formLoginDiv);
        }
        function handleFormSubmitList(value) {
            coopId = value;
            $coopLoginDiv.setAttribute('data-spinner', 'mask');
            loginAttempt(coopId, email, password, device, $coopLoginDiv);
        }
        function pushLoginGtm(esito) {
            var _a, _b, _c;
            const cooperativa = (_c = (_b = (_a = new URLSearchParams(location.search).get('cpvUtente')) === null || _a === void 0 ? void 0 : _a.split('|')[1]) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === null || _c === void 0 ? void 0 : _c.replace('-', '_');
            dataLayer.push({
                event: 'login',
                punto_vendita: pdvID,
                cooperativa: cooperativa || 'null',
                login_esito: esito 
            });
        }
        function loginAttempt(coopId, email, password, device, divLogin) {
            var body = { coopId, email, password, device };
            Fetch(getServicesEndpoint, {
                method: 'POST',
                data: body,
                token: {
                    enable: true,
                },
            })
                .then((response) => {
                var log = { message: 'Login' };
                _flog(0, log, { url: getServicesEndpoint, data: { email } }, response);
                if (response.header.result == 'OK') {
                    $errorLab.innerHTML = '';
                    $errordiv.classList.add('hidden');
                    $errordiv.style.display = 'none';
                    $wrapperCoopLoginSub.innerHTML = '';
                    pushLoginGtm('ok');
                    $formLoginDiv.classList.remove('hidden');
                    $coopLoginDiv.classList.add('hidden');
                    globalToken = response.payload.token;
                    var coopIdRequest;
                    if (coopId == null) {
                        coopIdRequest = response.payload.coopList[0].id;
                    }
                    else {
                        coopIdRequest = coopId;
                    }
                    globalCoopId = coopIdRequest;
                    getProfile(globalToken);
                }
                else {
                    let message;
                    pushLoginGtm('ko');
                    if (response.header.errorCode == 202) {
                        message = "L'email inserita è in fase di conferma, clicca sul link ricevuto via mail. <br> Non hai ricevuto la mail?";
                        $errorLab.innerHTML = message;
                        var linkElement = document.createElement('a');
                        linkElement.textContent = 'Reinvia mail';
                        linkElement.style.textDecoration = 'underline';
                        linkElement.style.cursor = 'pointer';
                        linkElement.style.marginLeft = '3px';
                        linkElement.className = 'resend-email-link';
                        linkElement.setAttribute('aria-label', 're-invia email di conferma registrazione');
                        linkElement.addEventListener('click', resendEmail);
                        $errorLab.appendChild(linkElement);
                    }
                    else {
                        message = response.header.errorMessage;
                        $errorLab.innerHTML = message;
                    }
                    $errordiv.classList.remove('hidden');
                    $errordiv.style.display = 'flex';
                    $formLoginDiv.classList.remove('hidden');
                    $coopLoginDiv.classList.add('hidden');
                    divLogin.removeAttribute('data-spinner');
                }
            })
                .catch((err) => {
                pushLoginGtm('ko');
                console.error('Error: ', err);
                $errorLab.innerHTML = 'Errore nella chiamata a servizio. Riprova più tardi.';
                $errordiv.classList.remove('hidden');
                divLogin.removeAttribute('data-spinner');
                _flog(0, err, { url: getServicesEndpoint, data: {} }, {});
            });
        }
        function resendEmail() {
            var url = { email: retrieveEmail(document), coopId: coopId, device: device };
            console.log('URL ', url);
            Fetch(ServicesEndpointRes, {
                method: 'POST',
                data: url,
                token: {
                    enable: true,
                },
            })
                .then((response) => {
                if (response.header.result == 'OK') {
                    console.log('OK');
                }
                else {
                    console.log('KO');
                }
            })
                .catch((err) => {
                console.error('Error: ', err);
            });
        }
        function setCookie(cname, cvalue) {
            document.cookie =
                cname + '=' + cvalue + ';domain=' + window.location.hostname + ';path=/;secure;';
        }
        function setRememberCPVCookie(cname, cvalue) {
            const d = new Date();
            d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
            let expires = "expires=" + d.toUTCString();
            document.cookie =
                cname + '=' + cvalue + ';domain=' + window.location.hostname + ';path=/;secure;' + expires;
        }
        function setCookieInfo(response) {
            document.cookie =
                'session_info=' +
                    response.payload.profile.coopId +
                    '|' +
                    response.payload.profile.pdv +
                    '|' +
                    response.payload.profile.mail +
                    '|' +
                    response.payload.profile.name +
                    '|' +
                    response.payload.profile.surname +
                    '|' +
                    response.payload.profile.birthdate +
                    '|' +
                    (response.payload.profile.eanCard != null && response.payload.profile.eanCard != '' ? 'Y' : 'N') +
                    '; domain = ' +
                    window.location.hostname +
                    '; path = /;secure;';
        }
        function getProfile(token) {
            var url = { token: token, coopId: globalCoopId };
            Fetch(ServicesEndpointPro, {
                method: 'POST',
                data: url,
                token: {
                    enable: true,
                },
            })
                .then((response) => {
                if (response.header.result == 'OK') {
                    checkUpdateDisclaimers(token, response);
                }
                else {
                    var message = response.header.errorMessage;
                    $errorLab.innerHTML = message;
                    $errordiv.classList.remove('hidden');
                    $formLoginDiv.classList.remove('hidden');
                    $coopLoginDiv.classList.add('hidden');
                    $formLoginDiv.removeAttribute('data-spinner');
                }
            })
                .catch((err) => {
                console.error('Error: ', err);
                $errorLab.innerHTML = 'Errore nella chiamata a servizio. Riprova più tardi.';
                $errordiv.classList.remove('hidden');
                _flog(0, err, { url: getServicesEndpoint, data: {} }, {});
                $formLoginDiv.removeAttribute('data-spinner');
            });
        }
        function verificaParametriURL() {
            const queryString = window.location.search.substring(1);
            const searchParams = new URLSearchParams(queryString);
            coopId = searchParams.get('coopId');
            let cooperativa = searchParams.get('cooperativa');
            if (coopId !== null && cooperativa !== null) {
                return true;
            }
            else {
                return false;
            }
        }
        function checkUpdateDisclaimers(token, responseGetProfile) {
            var userPrivacy = responseGetProfile.payload.privacyCoopItalia;
            var socio = responseGetProfile.payload.profile.eanCard != null ? 1 : 0;
            var coopidPrivacy = globalCoopId;
            var url = { coopId: coopidPrivacy, userType: socio };
            Fetch(endpointGetPrivacy, {
                method: 'POST',
                data: url,
                token: {
                    enable: true,
                },
            })
                .then((response) => {
                let searchIndexUserPrivacy;
                if (response.payload.optinPrivacy.length > 0) {
                    if (response.payload.optinPrivacy.length > 2) {
                        searchIndexUserPrivacy = userPrivacy.findIndex((privacy) => privacy.id == response.payload.optinPrivacy[0].id ||
                            privacy.id == response.payload.optinPrivacy[1].id ||
                            privacy.id == response.payload.optinPrivacy[2].id);
                    }
                    else if (response.payload.optinPrivacy.length == 2) {
                        searchIndexUserPrivacy = userPrivacy.findIndex((privacy) => privacy.id == response.payload.optinPrivacy[0].id ||
                            privacy.id == response.payload.optinPrivacy[1].id);
                    }
                    else {
                        searchIndexUserPrivacy = userPrivacy.findIndex((privacy) => privacy.id == response.payload.optinPrivacy[0].id);
                    }
                }
                if (searchIndexUserPrivacy == -1) {
                    showPrivacyModal = true;
                }
                if (showPrivacyModal) {
                    $formLoginDiv.removeAttribute('data-spinner');
                    createNewDisclaimer(coopidPrivacy, response, responseGetProfile);
                }
                else {
                    if (getCookie('delete_redirect') != '') {
                        setAllCookies(token, responseGetProfile);
                        window.location.href = '/auth/cancella-registrazione';
                    }
                    else {
                        if (responseGetProfile.payload.profile.mustResetPassword == "true" && (globalCoopId == '35' || globalCoopId == 35)) {
                            modal_reset_psw === null || modal_reset_psw === void 0 ? void 0 : modal_reset_psw.classList.remove('d-none');
                            $body === null || $body === void 0 ? void 0 : $body.classList.add('scrollLock');
                            $formLoginDiv.removeAttribute('data-spinner');
                        }
                        else if (getCookie('event_info') != '') {
                            setAllCookies(token, responseGetProfile);
                            window.location.href = '/eventi/ringraziamento';
                        }
                        else if (document.referrer == null ||
                            document.referrer.split('/')[2] != location.hostname ||
                            document.referrer.includes('auth') ||
                            document.referrer.includes('registrazione')) {
                            setAllCookies(token, responseGetProfile);
                            window.location.href = '/';
                        }
                        else {
                            setAllCookies(token, responseGetProfile);
                            window.location.href = document.referrer;
                        }
                    }
                }
            })
                .catch((err) => {
                $formLoginDiv.removeAttribute('data-spinner');
                console.log(err);
            });
        }
        function acceptNewDisclaimer(responseGetProfile, coopId, token) {
            $formLoginDiv.setAttribute('data-spinner', 'mask');
            let privacyCoopItalia = getPrivacyString();
            var url = { coopId: coopId, token: token, privacyCoopItalia: privacyCoopItalia };
            Fetch(endpointSetPrivacy, {
                method: 'POST',
                data: url,
                token: { enable: true },
            })
                .then((response) => {
                if (response && response.header.result === 'OK') {
                    if (responseGetProfile.payload.profile.mustResetPassword == "true" && (globalCoopId == '35' || globalCoopId == 35)) {
                        modal_reset_psw === null || modal_reset_psw === void 0 ? void 0 : modal_reset_psw.classList.remove('d-none');
                        $body === null || $body === void 0 ? void 0 : $body.classList.add('scrollLock');
                    }
                    if (getCookie('event_info') != '') {
                        setAllCookies(token, responseGetProfile);
                        window.location.href = '/eventi/ringraziamento';
                    }
                    else if (document.referrer == null ||
                        document.referrer.split('/')[2] != location.hostname ||
                        document.referrer.includes('auth') ||
                        document.referrer.includes('registrazione')) {
                        setAllCookies(token, responseGetProfile);
                        window.location.href = '/';
                    }
                    else {
                        setAllCookies(token, responseGetProfile);
                        window.location.href = document.referrer;
                    }
                }
                else {
                    $errorLab.innerHTML = 'Errore, riprovare';
                    $errordiv.classList.remove('hidden');
                    $errorLab.scrollIntoView({ behavior: 'smooth', block: 'end' });
                    $formLoginDiv.removeAttribute('data-spinner');
                }
            })
                .catch((err) => {
                $errorLab.innerHTML = 'Errore di servizio, riprovare più tardi...';
                $errordiv.classList.remove('hidden');
                $errorLab.scrollIntoView({ behavior: 'smooth', block: 'end' });
                $formLoginDiv.removeAttribute('data-spinner');
            });
        }
        function createNewDisclaimer(coopId, response, responseGetProfile) {
            var _a, _b;
            const $body = document.querySelector('body');
            const $modal = document.querySelector('.privacy-modal-update');
            const $btnAccept = $modal.querySelector('.accept');
            var privacy_container = document.querySelector('#privacy-container');
            var checkbox = $modal.querySelector('#checkbox-nazionale-modal');
            checkbox.addEventListener('click', enableOrDisableConfirmButton);
            if (notNazionale.indexOf(coopId) == -1) {
                document.getElementById('siNazionaleLabelDisclaimer').innerHTML =
                    response.payload.privacyLabel;
                document
                    .getElementById('siNazionaleLinkDisclaimer')
                    .setAttribute('href', response.payload.privacyLink);
            }
            var node = document.querySelector('.entry');
            for (let i = 0; i < response.payload.optinPrivacy.length; i++) {
                var obj = node.cloneNode(true);
                obj.id = 'discl-' + i;
                obj.classList.add('discl-remove');
                obj.style.textAlign = 'justify';
                var text = obj.querySelector('.li-entry');
                text.innerHTML = response.payload.optinPrivacy[i].text;
                var radioSi = document.createElement('input');
                radioSi.setAttribute('type', 'radio');
                radioSi.setAttribute('name', response.payload.optinPrivacy[i].id);
                radioSi.setAttribute('value', 'true');
                radioSi.setAttribute('id', 'privacy-ok-' + i);
                radioSi.classList.add('radio-ok-privacy');
                radioSi.required = true;
                radioSi.addEventListener('click', enableOrDisableConfirmButton);
                var labelText;
                if (response.payload.optinPrivacy[i].mandatory) {
                    labelText = 'Accetto<sup>*</sup>';
                }
                else {
                    labelText = 'Accetto';
                }
                var labelSi = document.createElement('label');
                labelSi.htmlFor = 'privacy-ok-' + i;
                labelSi.innerHTML = labelText;
                labelSi.style.marginRight = '20px';
                var radioNo = document.createElement('input');
                radioNo.setAttribute('type', 'radio');
                radioNo.setAttribute('name', response.payload.optinPrivacy[i].id);
                radioNo.setAttribute('value', 'false');
                radioNo.setAttribute('id', 'privacy-ko-' + i);
                radioNo.classList.add('radio-no-privacy');
                radioNo.addEventListener('click', enableOrDisableConfirmButton);
                var labelNo = document.createElement('label');
                labelNo.htmlFor = 'privacy-ko-' + i;
                labelNo.innerHTML = 'Non Accetto';
                var divRadio = obj.querySelector('.divRadio');
                divRadio.appendChild(radioSi);
                divRadio.appendChild(labelSi);
                divRadio.appendChild(radioNo);
                divRadio.appendChild(labelNo);
                if (response.payload.optinPrivacy[i].benefits !== undefined &&
                    response.payload.optinPrivacy[i].benefits.length > 0) {
                    var divBenefit = document.createElement('div');
                    divBenefit.classList.add('benefit');
                    divBenefit.classList.add('hidden');
                    divBenefit.id = 'divBen-' + i;
                    var divBenefitCol = document.createElement('div');
                    divBenefitCol.classList.add('col-12');
                    divBenefitCol.classList.add('coop-card-appartenza');
                    var ulBenefit = document.createElement('ul');
                    ulBenefit.id = 'ul-benefit';
                    ulBenefit.style.listStyle = 'none';
                    ulBenefit.classList.add('fa-ul'); 
                    for (let j = 0; j < response.payload.optinPrivacy[i].benefits.length; j++) {
                        var n = response.payload.optinPrivacy[i].benefits[j];
                        var linkBenefit = document.createElement('li');
                        linkBenefit.classList.add('labelField');
                        linkBenefit.style.marginBottom = '10px';
                        var span = document.createElement('span');
                        span.classList.add('fa-li');
                        var icon = document.createElement('i');
                        icon.classList.add('fas');
                        icon.classList.add('fa-check');
                        icon.classList.add('labelField');
                        icon.style.color = '#e30613';
                        span.appendChild(icon);
                        var textBenefit = document.createElement('p');
                        textBenefit.style.marginRight = '20px';
                        textBenefit.innerHTML = n.text + '<br>';
                        linkBenefit.appendChild(span);
                        linkBenefit.appendChild(textBenefit);
                        ulBenefit.appendChild(linkBenefit);
                    }
                    divBenefitCol.appendChild(ulBenefit);
                    divBenefit.appendChild(divBenefitCol);
                    obj.appendChild(divBenefit);
                    obj.style.padding = '10px';
                }
                obj.removeAttribute('hidden');
                privacy_container.appendChild(obj);
            }
            $modal.classList.remove('d-none');
            if (!((_a = document.querySelector('#formLoginDiv')) === null || _a === void 0 ? void 0 : _a.classList.contains('d-none'))) {
                (_b = document.querySelector('#formLoginDiv')) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
            }
            $btnAccept.removeEventListener('click', () => { });
            $btnAccept.addEventListener('click', (event) => {
                var _a, _b;
                event.preventDefault();
                $modal.classList.add('d-none');
                if ((_a = document.querySelector('#formLoginDiv')) === null || _a === void 0 ? void 0 : _a.classList.contains('d-none')) {
                    (_b = document.querySelector('#formLoginDiv')) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
                }
                acceptNewDisclaimer(responseGetProfile, globalCoopId, globalToken);
            });
        }
        function getPrivacyString() {
            var result = '';
            var privacy_container = document.querySelector('#privacy-container');
            var checkboxes = privacy_container.querySelectorAll('input[type=radio]:checked');
            for (let i = 0; i < checkboxes.length; i++) {
                var temp = checkboxes[i];
                result += 'id:' + temp.name + ',value:' + temp.value + ';';
            }
            return result;
        }
        function enableOrDisableConfirmButton(evt) {
            const $modal = document.querySelector('.privacy-modal-update');
            var privacy_container = $modal.querySelector('#privacy-container');
            var checkbox = $modal.querySelector('#checkbox-nazionale-modal');
            var radios = privacy_container.querySelectorAll('.radio-ok-privacy');
            var radios_no = privacy_container.querySelectorAll('.radio-no-privacy');
            var $btnAccept = $modal.querySelector('.accept');
            var disabled = false;
            for (let i = 0; i < radios.length; i++) {
                var temp = radios[i];
                var temp_no = radios_no[i];
                if (!temp.checked && !temp_no.checked) {
                    disabled = true;
                    break;
                }
                else
                    continue;
            }
            if (!checkbox.checked) {
                disabled = true;
            }
            console.log('Valore disabled del bottone: ' + disabled);
            $btnAccept.disabled = disabled;
        }
        function setPrivacyLink() {
            $formLoginDiv.setAttribute('data-spinner', 'mask');
            let endpoint = `/api/esb/user/getPrivacyDisclaimers?_format=form`;
            var url = { coopId: coopId, userType: 2 };
            Fetch(endpoint, {
                method: 'POST',
                data: url,
                token: {
                    enable: true,
                },
            })
                .then((response) => {
                document.getElementById('inf-privacy').setAttribute('href', response.payload.privacyLink);
                $formLoginDiv.removeAttribute('data-spinner');
            })
                .catch((err) => {
                $formLoginDiv.removeAttribute('data-spinner');
                console.error('Error: ', err);
            });
        }
        function setAllCookies(token, responseGetProfile) {
            setCookie('session_token', token);
            setCookie('session_email', email);
            setCookie('session_coopId', globalCoopId);
            setCookieInfo(responseGetProfile);
        }
    });
})(loginCoop || (loginCoop = {}));
